import React from "react";
import { getToken } from "../../../../../utils/token";
import instance from "../../../../../axios/instance";
import { useLoaderData, useNavigate } from "react-router-dom";
import { Back } from "iconsax-react";
import ConsultationSubscriptionDetails from "../../../../../components/treatments/SubscriptionItem";
import QuestionnaireSection from "../../../../../components/treatments/ConsultationQuestionnaire";

export const consultationItemLoader = async ({ params }) => {
  const token = getToken();
  const doctor = await instance.get("/doctor", {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  const res = await instance.get(
    `/telemedicine/doctor/consultation/item/${params.id}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  console.log(res.data)

  return { consultation: res.data, doctor: doctor.data };
};

export const ConsultationItemPage = () => {
  const { consultation, doctor } = useLoaderData();
  const navigate = useNavigate();
  const isAdmin = doctor.access === "admin";

  return (
    <>
      <div className="flex gap-x-2 mb-4 items-center">
        <Back
          size={30}
          onClick={() => window.history.back()}
          className="hover:text-primary cursor-pointer"
        />
        <div className="font-medium text-xl">{consultation.meeting_title}</div>
      </div>
      <div className="rounded-lg border my-5 px-5 py-4 grid md:grid-cols-3 lg:grid-cols-4 gap-x-3 gap-y-5 items-start">
        <div>
          <span className="text-gray-600 text-sm">Treatment:</span>
          <span
            className="font-medium block text-sm mt-1.5 break-words underline text-primary hover:opacity-80 cursor-pointer"
            onClick={() =>
              consultation.treatment?.id &&
              navigate(
                `/dashboard/settings/treatment-setup/treatments/${consultation.treatment.id}`
              )
            }
          >
            {consultation.treatment?.title || "N/A"}
          </span>
        </div>
        <div>
          <span className="text-gray-600 text-sm">Meeting Status:</span>
          <span className="font-medium block text-sm mt-1.5 break-words capitalize">
            {consultation.meeting_status}
          </span>
        </div>
        <div>
          <span className="text-gray-600 text-sm">Start:</span>
          <span className="font-medium block text-sm mt-1.5 break-words capitalize">
            {consultation.start}
          </span>
        </div>
        <div>
          <span className="text-gray-600 text-sm">End:</span>
          <span className="font-medium block text-sm mt-1.5 break-words capitalize">
            {consultation.end}
          </span>
        </div>
        <div>
          <span className="text-gray-600 text-sm">Patient Name:</span>
          <span className="font-medium block text-sm mt-1.5 break-words capitalize">
            {consultation.patient
              ? `${consultation.patient.lastname} ${consultation.patient.firstname}`
              : "N/A"}
          </span>
        </div>
        <div>
          <span className="text-gray-600 text-sm">Patient Phone:</span>
          <span className="font-medium block text-sm mt-1.5 break-words">
            {consultation.patient?.home_phone || "N/A"}
          </span>
        </div>
        <div>
          <span className="text-gray-600 text-sm">Patient Email:</span>
          <span className="font-medium block text-sm mt-1.5 break-words">
            {consultation.patient?.email_address || "N/A"}
          </span>
        </div>
        <div>
          <span className="text-gray-600 text-sm">Doctor:</span>
          <span className="font-medium block text-sm mt-1.5 break-words capitalize">
            {consultation.doctor
              ? `${
                  consultation.doctor?.prefix ? consultation.doctor?.prefix : ""
                } ${consultation.doctor.lastname} ${
                  consultation.doctor.firstname
                }`
              : "--"}
          </span>
        </div>
        <div>
          <span className="text-gray-600 text-sm">Payment Status:</span>
          <span className="font-medium block text-sm mt-1.5 break-words capitalize">
            {consultation?.subscription?.status === "canceled"
              ? "Canceled"
              : consultation.payment_status}
          </span>
        </div>
        {isAdmin && !consultation.subscription_id && (
          <div>
            <span className="text-gray-600 text-sm">Amount Paid:</span>
            <span className="font-medium block text-sm mt-1.5 break-words capitalize">
              ${+consultation.amount.toLocaleString()}
            </span>
          </div>
        )}
        <div>
          <span className="text-gray-600 text-sm">Payment Type:</span>
          <span className="font-medium block text-sm mt-1.5 break-words capitalize">
            {consultation.subscription_id ? "Subscription" : "One-time"}
          </span>
        </div>
        <div>
          <span className="text-gray-600 text-sm">Doses:</span>
          <span className="font-medium block text-sm mt-1.5 break-words capitalize">
            {consultation.doses !== "0" ? consultation.doses : "--"}
          </span>
        </div>
      </div>
      {consultation.subscription_id && isAdmin && (
        <div className="mt-10">
          <div className="font-medium text-xl mb-4">Subscription Details</div>
          <ConsultationSubscriptionDetails
            subscription={consultation.subscription}
            firstMonthPay={consultation.first_month_pay}
          />
        </div>
      )}
      {consultation.questionnaire && (
        <div className="mt-10">
          <div className="font-medium text-xl mb-4">Questionnaires</div>
          <QuestionnaireSection
            questionnaires={JSON.parse(consultation.questionnaire) || []}
          />
        </div>
      )}
    </>
  );
};
